const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

async function parseJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function fetchConceptos({ signal } = {}) {
  const response = await fetch(`${API_BASE_URL}/conceptos`, {
    method: 'GET',
    signal,
  });
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }
  const payload = await response.json();
  return payload?.data ?? [];
}

export async function createConcepto({ deConcepto, tpConcepto, feRegistro }) {
  const response = await fetch(`${API_BASE_URL}/conceptos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      de_concepto: deConcepto,
      tp_concepto: tpConcepto,
      fe_registro: feRegistro,
    }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function updateConcepto(cdConcepto, deConcepto) {
  const response = await fetch(`${API_BASE_URL}/conceptos/${cdConcepto}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ de_concepto: deConcepto }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function toggleConceptoStatus(cdConcepto) {
  const response = await fetch(`${API_BASE_URL}/conceptos/${cdConcepto}/anular`, {
    method: 'PATCH',
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}